import { gql } from 'graphql-request';

const getEntitiesQuery = (includeHiddenAliases = false) => gql`
  query allEntityTypes {
    ingressProjections {
      meta {
        id {
          name
          builtIn
        }
        typeId {
          name
          builtIn
        }
      }
    }
    externalProjections {
      meta {
        id {
          name
          builtIn
        }
        typeId {
          name
          builtIn
        }
      }
    }
    allEntityTypes {
      id {
        name
        builtIn
      }
      keyField
      fields {
        name
        builtIn
        displayName
        type
        repeated
        tags
        groupName
        isSupportedInBasicHistorical
        additionalInfo {
          hideFromMapping
        }
      }
    }
    metadataFields: metadataFieldsV2 {
      id {
        name
        builtIn
      }
      fields {
        name
        builtIn
        displayName
        type
        repeated
        tags: tagsList
        isSupportedInBasicHistorical
      }
    }
    projectionAliasPaths(
      includeIngressAliases: true
      includeRecommendations: true
      includeAggregationSteps: true
      ${includeHiddenAliases ? 'includeHiddenAliases: true' : ''}
    ) {
      projId {
        name
        builtIn
      }
      entityTypeId {
        name
        builtIn
      }
      projDisplayName
      aggregates {
        name
        builtIn
      }
      aliases {
        projId {
          name
          builtIn
        }
        entityTypeId {
          name
          builtIn
        }
        alias
        displayName
        usages
        fieldsRecommendation
        fieldsPopulation
        aggregationSteps
        isSupportedInBasicHistorical
        ${includeHiddenAliases ? 'hidden' : ''}
      }
    }
  }
`;

export const GET_ENTITIES = getEntitiesQuery();
export const GET_ENTITIES_WITH_HIDDEN_ALIASES = getEntitiesQuery(true);

export const FIELD_VISIBILITY = gql`
  query findFieldVisibilitiesByAccountId {
    findFieldVisibilitiesByAccountId {
      id
      projectionName
      builtInProjection
      fieldName
      config
    }
  }
`;

export const GET_MEASUREMENTS_AND_CALCULATED_DIMENSIONS = gql`
  query measurementsAndCalculatedDimensions {
    findMeasurementsByAccountId {
      measurement
      createdByUserId
      updatedByUserId
      id
    }
    findCalculatedDimensionsByAccountId {
      calculatedDimension
      createdByUserId
      updatedByUserId
      id
    }
  }
`;

export const GET_UI_CONFIG = gql`
  query getUIConfigByProjection($projectionName: String) {
    getUIConfigByProjection(projectionName: $projectionName)
  }
`;
